import ReRegion from './ReRegion'
import ReOrgStatusType from './ReOrgStatusType'
import ReMeasurementUnit from './ReMeasurementUnit'
import ReConstructionMaterial from './ReConstructionMaterial'
import ReConstructionCategory from "./ReConstructionCategory";
import ReMessageToAdminType from './ReMessageToAdminTypes/index'
import ReCharacteristic from './ReCharacteristic'
import ReDistrict from './ReDistrict'
import ReOrgs from './ReOrgs'
import ReOrgType from './ReOrgType'
import ReCity from "./ReCity"
import ReReferenceUnits from './ReReferenceUnits'
import ReObjectFunctionType from './ReObjectFunctionTypes';
import RePTMs from './RePTMs';
import PredictivePrice from './PredictivePrice';
import ReInterdigitCoefficient from './ReInterdigitCoefficient';
import TariffRate from './TariffRate';
import ReBuildType from './ReBuildType';
import ReStandardsDeterminants from './ReStandardsDeterminants';
import ResourceType from './ResourseType';
import ReZone from './ReZone';
import ReMechanism from './ReMechanism';
import ReCorrectionFactor from "./ReCorrectionFactor";
import { TFunction } from "i18next";
import ReSpentTimeUnit from './ReSpentTimeUnit';

export function getNriRoutes(t: TFunction) {
    const items = [
        {
            render: ReReferenceUnits,
            text: t('nri:reReferenceUnit')
        },
        {
            render: ReObjectFunctionType,
            text: t('nri:ReObjectFunctionType')
        },
        {
            render: RePTMs,
            text: t('nri:RePTM')
        },
        {
            render: PredictivePrice,
            text: t('nri:predictivePrice')
        },
        {
            render: ReBuildType,
            text: t('nri:reBuildType')
        },
        {
            render: ReCorrectionFactor,
            text: t('nri:reCorrectionFactor')
        },
        {
            render: ReZone,
            text: t('nri:reZone')
        },
        {
            render: ReStandardsDeterminants,
            text: t('nri:reStandardsDeterminant')
        },
        {
            render: ReInterdigitCoefficient,
            text: t('nri:reInterdigitCoefficients')
        },
        {
            render: TariffRate,
            text: t('nri:tariffRate')
        },
        {
            render: ReMechanism,
            text: t('nri:reMechanism')
        },
        {
            render: ResourceType,
            text: t('nri:resourceType')
        },
        {
            render: ReMeasurementUnit,
            text: t('nri:reMeasurementUnit')
        },
        {
            render: ReConstructionMaterial,
            text: t('nri:reConstructionMaterial'),
            catalog: true
        },
        {
            render: ReConstructionCategory,
            text: t('nri:reConstructionCategory'),
        },
        // {
        //     render: ReCharacteristic,
        //     text: t('nri:reCharacteristic')
        // },
        /*{
            render : RePossibleCharacteristic,
            text   : t('nri:rePossibleCharacteristic')
        },*/
        /*{
            render: ReOrgs,
            text: t('nri:reOrgs')
        },*/
        {
            render: ReOrgStatusType,
            text: t('nri:reOrgStatusType')
        },
        {
            render: ReOrgType,
            text: t('nri:reOrgType')
        },
        {
            render: ReRegion,
            text: t('nri:reRegion')
        },
        {
            render: ReDistrict,
            text: t('nri:reDistrict')
        },
        {
            render: ReCity,
            text: t('nri:reCity')
        },
        {
            render: ReMessageToAdminType,
            text: t('nri:reMessageToAdminType')
        },
        {
            render: ReSpentTimeUnit,
            text: t('nri:reSpentTimeUnit')
        }
    ]
    return items
}
